import { render, staticRenderFns } from "./paytype.vue?vue&type=template&id=57ed2414&scoped=true&"
import script from "./paytype.vue?vue&type=script&lang=js&"
export * from "./paytype.vue?vue&type=script&lang=js&"
import style0 from "./paytype.vue?vue&type=style&index=0&id=57ed2414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed2414",
  null
  
)

export default component.exports